<template>
  <div>
    <SystemErrorAlert></SystemErrorAlert>
    <div v-if="!is_ready">
      <load-overlay :absolute="true" :activate="true"></load-overlay>
    </div>
    <OfflineHome v-else-if="is_login == false"></OfflineHome>
  </div>
</template>

<script>
import { mapState } from "vuex";
import SystemErrorAlert from "@/components/SystemErrorAlert.vue";

import Profile from "@/components/profile/Profile.vue";
import Dashboard from "@/components/dashboard/Dashboard.vue";
import OfflineHome from "@/components/home/OfflineHome.vue";
import LoadOverlay from "@/components/helpers/LoadOverlay.vue";

export default {
  name: "HomeView",
  components: {
    SystemErrorAlert,
    Dashboard,
    OfflineHome,
    Profile,
    LoadOverlay,
  },
  data() {
    return {};
  },
  methods: {
    redirect_on() {
      this.$router.push({ name: "dashboard" });
    },
  },
  computed: {
    ...mapState(["is_login", "is_ready", "user_data", "requires_profile_data"]),
  },
  watch: {
    is_login(nval) {
      if (nval) {
        this.redirect_on();
      }
    },
  },
  mounted() {
    if (this.is_login) {
      this.redirect_on();
    }
  },
};
</script>
